"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionHistoryList = void 0;
const TimeUtil_1 = require("../../utils/TimeUtil");
class TransactionHistoryList extends Array {
    constructor() {
        super(...arguments);
        this.getEnteredTimeConverted = () => {
            const transactionHistoryList = new TransactionHistoryList();
            if (this.length > 0) {
                this.forEach(x => {
                    x.enteredDateConverted = (0, TimeUtil_1.zonedDateTimeFor)(x.date).format('MMM D, YYYY');
                    x.enteredTimeConverted = (0, TimeUtil_1.zonedDateTimeFor)(x.date).format('hh:mm a');
                    transactionHistoryList.push(x);
                });
            }
            return transactionHistoryList;
        };
    }
}
exports.TransactionHistoryList = TransactionHistoryList;
//# sourceMappingURL=TransactionHistoryList.js.map